export default "__VITE_ASSET__106e1c00__"